import React from 'react'
import { useTranslation } from 'react-i18next'
import { Alert } from '@pandiafi/design-system'

import { ResidentAppErrorBoundary } from 'components/ResidentAppErrorBoundary/ResidentAppErrorBoundary'

interface AttachmentLinkErrorHandlerProps {
  children: React.ReactNode
}

export const AttachmentLinkErrorHandler: React.FC<
  AttachmentLinkErrorHandlerProps
> = ({ children }) => {
  const [t] = useTranslation(['errors'])

  const fallbackRender = () => {
    return (
      <Alert variant="danger" className="w-full justify-start">
        {t('other.failedToOpenAttachment')}
      </Alert>
    )
  }

  return (
    <ResidentAppErrorBoundary fallbackRender={fallbackRender}>
      {children}
    </ResidentAppErrorBoundary>
  )
}
